// extracted by mini-css-extract-plugin
export default {"Paragraph":"Paragraph_ks6YN"};